import { render, staticRenderFns } from "./stockUsedHistory.vue?vue&type=template&id=632cb416&"
import script from "./stockUsedHistory.vue?vue&type=script&lang=js&"
export * from "./stockUsedHistory.vue?vue&type=script&lang=js&"
import style0 from "./stockUsedHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports